import api from './api';

// ============================================================
// Service do wizard de onboarding (T1 / S6).
// Espelha back/controller/onboarding/Controller.Onboarding.pas.
//
// Endpoints:
//   GET    /v1/onboarding/checklist
//   GET    /v1/onboarding/pendente
//   POST   /v1/onboarding/etapa/:etapa/concluir
//   POST   /v1/onboarding/etapa/:etapa/pular
//   POST   /v1/onboarding/reiniciar
// ============================================================

const BASE = '/v1/onboarding';

export const obterChecklist = async () => {
  const { data } = await api.get(`${BASE}/checklist`);
  return data;
};

export const verificarPendente = async () => {
  const { data } = await api.get(`${BASE}/pendente`);
  return data;
};

export const concluirEtapa = async (etapa, dados) => {
  const body = dados ? { dados } : {};
  const { data } = await api.post(
    `${BASE}/etapa/${encodeURIComponent(etapa)}/concluir`,
    body,
  );
  return data;
};

export const pularEtapa = async (etapa) => {
  const { data } = await api.post(
    `${BASE}/etapa/${encodeURIComponent(etapa)}/pular`,
  );
  return data;
};

export const reiniciarOnboarding = async () => {
  const { data } = await api.post(`${BASE}/reiniciar`);
  return data;
};

// Constantes compartilhadas (etapas espelhadas do backend para uso na UI).
export const ETAPAS_ORDEM = [
  'empresa',
  'fiscal',
  'produtos',
  'clientes',
  'pagamentos',
  'primeiro_pedido',
];
